import React, { useLayoutEffect, useState } from "react";
import { useSelector } from "react-redux";
import { isEmpty, isUndefined } from "lodash";
import PropTypes from "prop-types";
import Spinner from 'react-bootstrap/Spinner';
import ProvinciaCantonDistrito from "@components/ProvinciaCantonDistrito/ProvinciaCantonDistrito";
import useMediaQuery from "app/hooks/useMediaQuery";
import {objectToQueryString} from "@helpers/utils.js";
import "./Bienes.css";

SearchFormBienes.propTypes = {
    buildParams:PropTypes.func,
    loading:PropTypes.bool,
    setCurBien: PropTypes.func,
};

function SearchFormBienes({buildParams=()=>{}, loading, setCurBien, ...props}) {
    const is4K = useMediaQuery('(min-width: 3840px)');
    const isFullHD = useMediaQuery('(min-width: 1920px)');
    const isMidLaptop = useMediaQuery('(min-width: 1366px)');

        //Declaración de constantes de métodos de estado
  const [searching, setSearching] = useState(false);
  const [valores, setValores] = useState({});
  const [clearLocality, setClearLocality] = useState(true)

  const {tiposBien} = useSelector(
    ({Base}) => Base.Catalogos
  );

  useLayoutEffect(()=>{
    setSearching(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]); 

  const getLocality=(provincia, canton, distrito) =>{
    let values=valores;  
    const prov=!isEmpty(provincia) ? provincia[0]?.Id : 0;
    const cant=!isEmpty(canton) ? canton[0]?.Id : 0;
    const dist=!isEmpty(distrito) ? distrito[0]?.Id : 0;   
    
    prov === 0 ? delete values.IdProvincia : values={...values, IdProvincia:prov}
    cant === 0 ? delete values.IdCanton : values={...values, IdCanton:cant}
    dist === 0 ? delete values.IdDistrito : values={...values, IdDistrito:dist} 
    
    setValores(values)
    setClearLocality(true)
  }

  const handleChange=(event)=>{
    let values=valores;
    
    (isUndefined(event.target.value) || event.target.value === "" || event.target.value === 0 || event.target.value === '0') ? 
        delete values[event.target.name]
    : values={...values, [event.target.name]: event.target.value} 
    setValores(values);
  }

  const handleSubmit=()=>{      
      setCurBien(0)
      const query=objectToQueryString(valores)
      buildParams(query)      
      setClearLocality(true)
  }

  const renderButtonBuscar=()=>(
    <div className="bienes-fields-grow" style={{paddingTop:"30px"}}>
        {searching ?
            <button className="btn btn-secondary btn-lg ps-4 pe-4" type="button" disabled>
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                &nbsp;Buscando...
            </button>
        :                    
            <button type="button" className="btn btn-secondary btn-lg ps-4 pe-4" onClick={handleSubmit}>Buscar</button>
        }
    </div>
  )

    return (
        <div className="d-flex flex-column">
            
            <div className="bienes-fields-arrange">
                <div className="bienes-fields-grow">
                    <label className="fs-5">Tipo de Bien</label>                    
                    <select
                        id="IdTipoBien"
                        name="IdTipoBien"
                        className="form-select3"
                        aria-label="Seleccione un Tipo de Bien"
                        defaultValue={0}          
                        onChange={(e) => handleChange(e)}
                        >
                        <option value={0} >Todos</option>                        
                        {tiposBien && tiposBien?.map((item, index) => {
                            return (
                            <option key={index} value={item.Id}>
                                {item.Tipo}
                            </option>
                            );
                        })}
                    </select>
                </div>
                <div className="bienes-fields-grow">
                    <label className="fs-5">Número de expediente</label>
                    <input 
                        type="text" 
                        className={is4K || isFullHD || isMidLaptop ? "form-control inputw90" : "form-control"} 
                        id="NumeroExpediente"
                        name="NumeroExpediente"                        
                        placeholder="Todos"
                        defaultValue=""          
                        onChange={(e) => handleChange(e)}
                    />
                </div>
                <div className="bienes-fields-grow">&nbsp;</div>
            </div>
            <ProvinciaCantonDistrito getLocality={getLocality} clearLocality={clearLocality}/>
            <div className="bienes-fields-arrange pt-3 pb-5">
                <div className="bienes-fields-grow">
                    <label className="fs-5">Precio mínimo</label>
                    <input type="number" className="form-control inputw90" id="PrecioMinimo" name="PrecioMinimo" placeholder="Todos" onChange={(e) => handleChange(e)}/>
                </div>
                <div className="bienes-fields-grow">
                    <label className="fs-5">Precio máximo</label>
                    <input type="number" className="form-control inputw90" id="PrecioMaximo" name="PrecioMaximo" placeholder="Todos" onChange={(e) => handleChange(e)}/>
                </div>                
                {renderButtonBuscar()}
            </div>            
            {searching &&
                <div className="d-flex justify-content-center pt-5 pb-5">
                    <div className="ps-1 pe-1"><Spinner animation="grow" variant="secondary" size="sm"/></div>
                    <div className="ps-1 pe-1"><Spinner animation="grow" variant="secondary" size="sm"/></div>
                    <div className="ps-1 pe-1"><Spinner animation="grow" variant="secondary" size="sm"/></div>
                    <div className="ps-1 pe-1"><Spinner animation="grow" variant="secondary" size="sm"/></div>
                    <div className="ps-1 pe-1"><Spinner animation="grow" variant="secondary" size="sm"/></div>
                </div>
            }
        </div>
    );
}

export default SearchFormBienes;